module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#speaker",
      toString: function () {
        return this.url;
      }
    }